function paraMoedaReal(valor, casasDecimais) {
    if (!isNaN(valor)) {
        let valorRetorno = valor.toLocaleString('pt-BR', {
            minimumFractionDigits: casasDecimais,
            style: 'currency',
            currency: 'BRL',
            useGrouping : false
        });

        return valorRetorno;
    }
}

export default paraMoedaReal;